<template>
  <LoadingOverlay :loading="isPending" :error="error" />
</template>

<script setup lang="ts">
import { UseMutationReturnType } from "@tanstack/vue-query";
import LoadingOverlay from "@/shared/components/LoadingOverlay.vue";

const props = defineProps<{
  mutation: UseMutationReturnType<any, Error, any, any>;
}>();

const { isPending, isError, error } = props.mutation;
</script>
